import React from 'react';
import PcaHeader from '../Components/pca/PcaHeader';
import PcaHero from '../Components/pca/PcaHero';
import PcaScreenshots from '../Components/pca/PcaScreenshots';
import PcaAbout from '../Components/pca/PcaAbout';
import PcaWhy from '../Components/pca/PcaWhy';
import PcaWhyNot from '../Components/pca/PcaWhyNot';
import PcaFounder from '../Components/pca/PcaFounder';
import PcaHowItWorks from '../Components/pca/PcaHowItWorks';
import PcaTestimonials from '../Components/pca/PcaTestimonials';
import PcaPricing from '../Components/pca/PcaPricing';
import PcaFAQ from '../Components/pca/PcaFAQ';
import PcaFooter from '../Components/pca/PcaFooter';
import './PcaLanding.css';

function PcaLanding() {
  return (
    <div className="pca-landing-root">
      <PcaHeader />
      <PcaHero />
      <PcaScreenshots />
      <PcaAbout />
      <PcaWhy />
      <PcaWhyNot />
      <PcaFounder />
      <PcaHowItWorks />
      <PcaTestimonials />
      <PcaPricing />
      <PcaFAQ />
      <PcaFooter />
    </div>
  );
}

export default PcaLanding;
